import React, { useState } from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

interface QueryProps {
	context: string | null;
	onChange: (value: string | null) => void;
};

const options = [
	{id: '', name: 'None'},
	{id: '1', name: 'Home'},
	{id: '2', name: 'Office'},
	{id: '3', name: 'Outside'},
	{id: '4', name: 'Computer'},
	{id: '5', name: 'Hermine'},
	{id: '6', name: 'Contact'},
	{id: '7', name: 'what?'},
	{id: '8', name: 'Offcom'},
	{id: '9', name: 'Everywhere'},
];

export default function ContextComplete ({context, onChange}: QueryProps) {
	const [value, setValue] = React.useState<string>(context ? context : '');
	const handleChange = (event: SelectChangeEvent) => {
		const v = event.target.value as string;
		setValue(v);
		onChange((v && v!=='') ? v : null);
	};
	return (
		<Select
			label="Context"
			size="small"
			value={value}
			onChange={handleChange}
		>
			{
				options.map( (element, index) => {
					return (<MenuItem key={element.id} value={element.id}>{element.name}</MenuItem>);
				})
			}
		</Select>
	);
}
